import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { exigirSesion } from '../nucleo/autorizacion/guardian.js';
import { rutaInicialDe } from '../nucleo/autorizacion/sesion.js';
import { rutaRaiz } from './raiz.js';

/**
 * Con qué rol entra el super administrador, feature 36. Fuera de los tres grupos porque no es de
 * ninguno: se llega antes de elegir. Quien no tiene la marca vuelve a su vista, y si llegara igual,
 * la base le niega el cambio.
 */
export const rutaElegirRol = createRoute({
  getParentRoute: () => rutaRaiz,
  path: '/elegir-rol',
  beforeLoad: ({ context }) => {
    const sesion = exigirSesion(context);
    if (!sesion.puedeElegirRol) throw redirect({ to: rutaInicialDe(sesion.rol), replace: true });
    return { sesion };
  },
  component: lazyRouteComponent(() => import('./elegir-rol-pantalla.js'), 'RutaElegirRol'),
});
